import React from "react";
import closeIcon from "../../../../../assets/icons/closeIcon.svg";
import "./company-dashboard-all-objective-drawer-header.scss";

const CompanyDashboardAllObjectiveDrawerHeader: any = (props: any) => {
  const {
    setIsShowAllObjectiveDrawer,
    fetchObjectives,
    fetchUpcomingMilestones,
    fetchAllYearsForObjectives,
    fetchAllYearsForInitiatives,
  } = props;
  return (
    <div className="company-dashboard-all-objective-drawer-header">
      <div className="company-dashboard-all-objective-drawer-header-content">
        <div className="company-dashboard-all-objective-drawer-header-content-label">
          Objective Detail
        </div>
        <div className="company-dashboard-all-objective-drawer-header-content-action">
          <button
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
            }}
            onClick={() => {
              setIsShowAllObjectiveDrawer(false);
              fetchObjectives();
              fetchUpcomingMilestones({});
              fetchAllYearsForObjectives();
              fetchAllYearsForInitiatives();
            }}
          >
            <img src={closeIcon} alt="close" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyDashboardAllObjectiveDrawerHeader;
